import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getLocationBasic } from '../Api'

export default generateApiAction({
  baseType: Types.LOCATIONS.GET.BASIC,
  api: getLocationBasic,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/locations/GetBasicAction.js